<template>
  <div>
    <MdTitle v-bind:Text="'Prior Authorization Errors'" />

    <b-row>
      <!--<div class="col-md-6 offset-md-6">-->
      <div class="col-sm-12 col-md-6 mb-2 offset-md-6">
            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
              <div class="input-group">
                <input 
                  type="text" 
                  class="form-control"
                  v-model="search"   
                  @keyup.enter="Find">
                  <div class="input-group-append">
                    <div class="input-group-append">
                      <MdButton 
                        v-bind:Name="'btnsearchinput'"
                        v-bind:VariantProp="'btn btn-sm search-attached'"
                        v-bind:IconClass="'mdi mdi-magnify'"
                        v-on:click="Find">
                      </MdButton>
                    </div>
                  </div>
                </div>
        </div>
      </div>
    </b-row>

    <MdTablePaginationClient 
        v-bind:fields="fields"
        v-bind:items="items"
        v-bind:totalRows="totalRows"              
        v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
        v-bind:currentPage="currentPage"
        v-bind:perPage="perPage" 
        v-bind:pageOptions="pageOptions"
        :editIconEvent="EditPrior"  
        v-bind:VisibleEditIcon="true"
        :RowClick="RowClicked"
        :pageChanged="pageChanged"                
        :perPageFunction="PerPageFunction">                
    </MdTablePaginationClient>

    <MdPriorAuthorization v-if="openPriorAuthorizationModal"
        v-bind:TitleWindow="$t('Shared.PriorAuthorization')"
        v-bind:PatientCode="PatientCode"
        @getCancel="onCancel($event)"
        @getCodeConditionOK="onCodeConditionOk($event)">
    </MdPriorAuthorization>
  </div>
</template>

<script>

  import DCSService from '@/services/dcs.service'
  import ShowMessage from '@/components/messages/ShowMessage.js'
  import Utils from "@/common/utils";

  export default {
    name: 'dcsPriorAuthoErrors',

    mixins: [ShowMessage],

    props: {
      DCSPriorAuthoErrorsFilter: Object
    },

    data() {
      return {
        items: [],
        search:"",
        openPriorAuthorizationModal:false,
        PatientCode:"",
        itemsCopy:[],
        fields: [              
          { key: 'message', sortable: true, label: this.$t('Shared.Description'), class: 'text-rigth' },      
          { key: 'patientCode', sortable: true, label: this.$t('Shared.PatientCode'), class: 'text-rigth' }, 
          { key: 'patientName', sortable: true, label: this.$t('Shared.PatientName'), class: 'text-rigth' },
          { key: 'contactDate', sortable: true, label: this.$t('Shared.ConDate'), class: 'text-rigth' },
          { key: 'formTitle', sortable: true, label: this.$t('Shared.NoteName'), class: 'text-rigth hidden' }, 
          { key: 'activity', sortable: true, label: this.$t('Shared.Activity'), class: 'text-rigth' },          
          { key: 'startTime', sortable: true, label: this.$t('MdNote.STARTTIME'), class: 'text-rigth' }, 
          { key: 'endTime', sortable: true, label: this.$t('MdNote.ENDTIME'), class: 'text-rigth' }, 
          { key: 'duration', sortable: true, label: this.$t('Shared.Duration'), class: 'text-rigth' },           
        ],

        totalRows: 0,
        ShowMessageIsEmpty: false,
        currentPage: 1,
        perPage: 10,
        pageOptions: [5, 10, 15,20,30,40,50],
        OptionsRightMenu:{
          visible:false,
          btnvisible:false,
          ItemsList:[],
          favButtonAtion: false
        },
      }
    },
    
    methods: {

      Find(){
        this.items = this.itemsCopy;
        var arr = this.items;
        var temp = [];
        if(this.search){
         arr.forEach(element => {
           if(element.message && element.message.toUpperCase().includes(this.search.toUpperCase()) ||
            element.patientCode && element.patientCode.toUpperCase().includes(this.search.toUpperCase()) ||
            element.patientName && element.patientName.toUpperCase().includes(this.search.toUpperCase()) ||
            element.contactDate && element.contactDate.toUpperCase().includes(this.search.toUpperCase()) ||
            element.formTitle && element.formTitle.toUpperCase().includes(this.search.toUpperCase()) ||
            element.activity && element.activity.toUpperCase().includes(this.search.toUpperCase()) ||
            element.startTime && element.startTime.toUpperCase().includes(this.search.toUpperCase()) ||
            element.endTime && element.endTime.toUpperCase().includes(this.search.toUpperCase()) ||
            element.duration && element.duration.toString().toUpperCase().includes(this.search.toUpperCase())
          ){
              temp.push(element);
           }
        });
        }else{
           temp = this.itemsCopy;
        }
      
         this.items = temp;
         this.totalRows = this.items.length;
      },

      onCancel(){
        this.openPriorAuthorizationModal = false;
      },

      onCodeConditionOk(){
         this.openPriorAuthorizationModal = false;
      },

      EditPrior(row){
        this.PatientCode = row.patientCode;
        this.openPriorAuthorizationModal = true;       
      },

      RowClicked(){

      },

      getAll(){
        DCSService.getDcsPriorAuthoErrors(this.DCSPriorAuthoErrorsFilter)
          .then((response) => { 
            if(response.data && response.data.length > 0){   
              this.items = response.data;              
              this.items.forEach(function(element) {                           
                  if(element.contactDate)	
                    element.contactDate = Utils.formatterDateToString(element.contactDate);

                 /* if(element.startTime)
                    element.startTime = Utils.formatTime2(element.startTime);

                  if(element.endTime)
                    element.endTime = Utils.formatTime2(element.endTime);*/
              });
              this.itemsCopy = [...this.items];
            }
            this.ShowMessageIsEmpty = this.items.length == 0;
          })
          .catch(error => {
            if (error.response) {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
            } 
          });  
      },

      pageChanged (page) {            
        this.currentPage = page;   
      },

      PerPageFunction(perpage){
        this.perPage = perpage;  
        this.currentPage = 1;
      },

    },
    
    mounted() {
      this.getAll();

      this.OptionsRightMenu.visible = false;
      this.OptionsRightMenu.ItemsList = []
      this.$emit('getVisibleMenu', this.OptionsRightMenu);
      this.$emit('getBtnRightMenu', this.OptionsRightMenu);
    }
  };
</script>


